<div class="modal-header" appCustomAutofocus>
    <h3>I-9 Utility</h3>
</div>
<div class="modal-body">
    <div *ngIf="alert">
        <div class="alert" [ngClass]="'alert-' + (alert.type || 'default')" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <h6>Use this process to send corrected I-9's to each new hire's HR Resource Master.</h6>
    <div class="row">
        <div class="col-lg-5" style="margin-bottom:5px;">
            <strong>From Date: <span style="color:red;">*</span></strong>

            <div class="input-group">
                <input type="text"
                       class="form-control"
                       bsDatepicker
                       #fromdp="bsDatepicker"
                       [(ngModel)]="formData.fromDate"
                       [outsideClick]="true"
                       [bsConfig]="datePickerOptions"
                       [readonly]="mobileMode"
                       (ngModelChange)="getList()"
                       style="background-color:#ffffff">
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary"
                            (click)="fromdp.show()"
                            [attr.aria-expanded]="fromdp.isOpen">
                        <i class="modus-icons align-bottom">calendar</i>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-5" style="margin-bottom:5px;">
            <strong>To Date: <span style="color:red;">*</span></strong>
            <div class="input-group">
                <input type="text"
                       class="form-control"
                       bsDatepicker
                       #todp="bsDatepicker"
                       [(ngModel)]="formData.toDate"
                       [outsideClick]="true"
                       [bsConfig]="datePickerOptions"
                       [readonly]="mobileMode"
                       (ngModelChange)="getList()"
                       style="background-color:#ffffff">
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary"
                            (click)="todp.show()"
                            [attr.aria-expanded]="todp.isOpen">
                        <i class="modus-icons align-bottom">calendar</i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div>
        <span *ngIf="i9List != null && i9List?.length == 0">There are no employee on the selected date range...</span>
        <strong *ngIf="i9List?.length > 0">Employee List:</strong>
        <ng-select *ngIf="i9List?.length > 0" style="max-height:400px; min-width: 135px;"
                   class="row col-lg-6"
                   [items]="i9List"
                   bindLabel="name"
                   [(ngModel)]="formData.selectedEmployee"
                   [multiple]="true"
                   placeholder="None Selected"
                   [closeOnSelect]="false"
                   [clearOnBackspace]="false"
                   dropdownPosition="bottom"
                   (change)="employeeUpdate()">
            <ng-template ng-header-tmp>
                <div>
                    <button class="btn btn-sm btn-tertiary" (click)="onSelectAll()"><i class="modus-icons align-bottom">check</i>Select All</button>
                    <button class="btn btn-sm btn-tertiary" (click)="onClearAll()"><i class="modus-icons align-bottom">close</i>Select None</button>
                </div>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <span *ngIf="items?.length == 1" class="ng-value">{{items[0].name}}</span>
                <span *ngIf="items?.length > 1" class="ng-value">{{items.length}} Selected</span>
            </ng-template>
        </ng-select>
    </div>
</div>
<div class="modal-footer">
    <span style="padding-right:20px;" *ngIf="loading">
        Processing {{progressCurrent}}...<img src="/Cache/images/icon_load.gif" alt="Loading..." />
    </span>
    <button type="button" class="btn btn-success" (click)="genClicked()" [disabled]="formData.toDate == null || formData.fromDate == null || i9List?.length < 1 || count < 1 || loading">Send to Vista</button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>
